import { jsx } from "react/jsx-runtime";
import { ApolloClient, InMemoryCache, HttpLink } from "@apollo/client";
import { useSetBlockSignal } from "@zillow/cms-utils";
import { SearchBox } from "@zillow/search-box";
import { event } from "@zillow/universal-analytics";
import { useRef, useMemo } from "react";
function isSuggestionWithZpid(selection) {
  return typeof selection === "object" && selection !== null && "data" in selection && typeof selection.data === "object" && selection.data !== null && "zpid" in selection.data && typeof selection.data.zpid === "number";
}
function createSearchBoxApolloClient(uri = "https://zg-graph-dev.int.zgcp-federated-nonprod-k8s.zg-int.net/graphql/") {
  return new ApolloClient({
    ssrMode: typeof window === "undefined",
    link: new HttpLink({
      uri,
      credentials: "same-origin",
      headers: {
        "x-caller-id": "zrs-cms"
      }
    }),
    cache: new InMemoryCache()
  });
}
const SellerAddressSearch = ({
  propertySearchConfigValues: {
    graphURL
  },
  placeholder = "Enter your home address",
  size = "md",
  id
}) => {
  const inputRef = useRef(null);
  const setSignal = useSetBlockSignal();
  const zgGraphClient = useMemo(() => createSearchBoxApolloClient(graphURL), [graphURL]);
  const handleSubmit = (value) => {
    if (!isSuggestionWithZpid(value)) return;
    const zpid = value.data.zpid;
    setSignal("propertySearch.zpid", zpid);
    sessionStorage.setItem("seller-go-big-zpid", JSON.stringify(zpid));
    event({
      // https://dataportal.zillowgroup.net/event-registry/2055
      envelope: {
        event_type_id: "2055",
        event_type_version_id: "1",
        event_template_id: "126",
        event_template_version_id: "1"
        // Master ID: 2055.1.126.1
      },
      clickstream_trigger: {
        trigger_type_nm: "interaction",
        trigger_location_nm: "cms",
        trigger_source_nm: "cms_seller_address_search",
        trigger_object_nm: "no_trigger_object"
      },
      semantic: {
        semantic_event_nm: "cms_submit"
      },
      cms_info: {
        block_id: id || "",
        block_type_cd: "mops_seller_address_search",
        block_target_url: "",
        block_displayed_txt: placeholder,
        form_business_line_txt: "sell",
        form_submit_label: "magnifying glass icon"
      }
    });
  };
  const boxProps = {
    clientId: "zrs-cms",
    abTests: {
      SXP_SEARCH_BOX_URL_ADDRESS: "BDP_HDP_SRP"
    },
    inputRef,
    handleSubmit,
    recentSearchLocalStorageKey: "recentSearchesEnhanced",
    fetchSavedHomes: true,
    fetchSavedSearches: true,
    platform: "CCMS",
    filterSuggestions: (suggestions) => suggestions.filter((suggestion) => suggestion.category === "ADDRESS"),
    platformConfig: {
      CCMS: {
        placeholderText: placeholder,
        supportsLocationIcon: false
      }
    },
    size,
    resultTypes: ["ADDRESSES"],
    zgGraphClient
  };
  return (
    // @ts-expect-error - CCMS platform is valid at runtime but not in library types
    /* @__PURE__ */ jsx(SearchBox, { ...boxProps })
  );
};
export {
  SellerAddressSearch as default
};
